export default __webpack_public_path__ + "static/media/undraw_color_palette_yamk.bf64d2c5.svg";